/* Ethics media slot: emerald-toned placeholder until the Founder uploads
   the final image through /admin/academy-ethics-media. */
export function EthicsImage({ media, assetKey, className = "", ratio = "aspect-[3/2]", alt = "" }) {
  const m = media?.[assetKey];
  if (m?.fileUrl) {
    return (
      <img src={m.fileUrl} alt={alt || m.altText || ""} loading="lazy"
        data-testid={`ethics-asset-${assetKey}`}
        className={`block w-full h-full object-cover ${className}`} />
    );
  }
  return (
    <div data-testid={`ethics-slot-${assetKey}`} role="img"
      aria-label={m?.intendedLocation || assetKey}
      className={`w-full ${ratio} flex flex-col items-center justify-center gap-2 border border-[#c8a95a]/25 bg-[#2b1a1a] text-center px-6 ${className}`}>
      <span className="text-[10px] tracking-[0.3em] uppercase text-[#c8a95a]/80 font-mono">{assetKey}</span>
      <span className="text-xs text-emerald-100/50 max-w-sm">{m?.intendedLocation || ""}</span>
      <span className="text-[10px] text-emerald-100/35">{m?.aspectRatio || ""}</span>
    </div>
  );
}

export function RubyShield({ size = 40, className = "" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" aria-hidden className={className}>
      <circle cx="20" cy="20" r="18" fill="none" stroke="#c8a95a" strokeWidth="1" opacity="0.7" />
      <circle cx="20" cy="20" r="11" fill="none" stroke="#c86058" strokeWidth="1" opacity="0.8" />
      <circle cx="20" cy="9" r="2.2" fill="#c8a95a" opacity="0.9" />
      <circle cx="20" cy="20" r="4" fill="#c86058" opacity="0.85" />
    </svg>
  );
}

export const STATUS_LABELS = {
  none: "Not Entered", active: "In Practice", ready: "Ready to Continue",
  renew: "Requires Further Practice", done: "Completed",
};
